import { connect } from "react-redux";
import * as authActions from "store/auth";
import * as commonActions from "store/common";

import AuthPage from "./AuthPage";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  login: values => dispatch(authActions.login(values)),
  saveENV: token => dispatch(authActions.saveENV(token)),
  saveMobileLayout: height => dispatch(commonActions.saveMobileLayout(height)),
  logRequest: params => dispatch(commonActions.logRequest(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthPage);
